// This hook returns an array of 'string blobs' that stringifies each object within an array.
function useGetBlob(objectsToBlobify: any[]): string[] {
  const blobs: string[] = [];

  // debugger;
  objectsToBlobify.forEach((obj) => {
    let blobIterator = '';
    Object.values(obj).forEach((value, index) => {
      blobIterator += JSON.stringify(value);
      if (index + 1 === Object.values(obj).length) {
        blobs.push(blobIterator);
      }
    });
  });

  return blobs;
}

export default useGetBlob;
